import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import InstagramIcon from "@material-ui/icons/Instagram";

import GitHubIcon from "@material-ui/icons/GitHub";
import "../styles/NavBar.css";
import { ReactComponent as Logo } from './logo.svg'; // Adjust the path if necessary


class NavBar extends React.Component {
  render() {
    return (
      <Navbar fixed="top" className="bg-body-tertiary">
        <Container>
        <Logo style={{ width: '25px', height: '25px' }} />

          <Navbar.Brand href="#"> &nbsp;&nbsp;&nbsp;R e p a i r N e t&nbsp;&nbsp;&nbsp;&nbsp;</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="#intro">Home</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#projects">Features</Nav.Link>
              <Nav.Link href="#Team">Team</Nav.Link>
              <Nav.Link href="#Team">Contact US</Nav.Link>
            </Nav>
            <Nav className="ml-auto">
              <Nav.Link href="https://www.instagram.com/repairnet101/">
                <InstagramIcon style={{ fontSize: 20 }}></InstagramIcon>
              </Nav.Link>
              <Nav.Link href="https://github.com/jojo142/RepairNet" target="_blank">
                <GitHubIcon style={{ fontSize: 19 }}></GitHubIcon>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default NavBar;
